import AbstractEntity from "../AbstractEntity";

export default class Intervention extends AbstractEntity {
    _id;
    _companyId;
    _artisanId;
    _invoiceFileId;
    _invoicePreTaxAmount;
    _token;
    _closedAt;
    _orderId;
    _artisanCommentsId;


    getId() {
        return this._id;
    }

    getCompanyId() {
        return this._companyId;
    }

    getArtisanId() {
        return this._artisanId;
    }

    getInvoiceFileId() {
        return this._invoiceFileId;
    }

    getInvoicePreTaxAmount() {
        return this._invoicePreTaxAmount;
    }

    getToken() {
        return this._token;
    }

    getClosedAt() {
        return this._closedAt;
    }

    getOrderId() {
        return this._orderId;
    }

    getArtisanCommentsId() {
        return this._artisanCommentsId;
    }

    getClassName() {
        return "intervention";
    }
}